import { convertArrayToKeyedObject, genObjectWithDefaultKey } from '../utils/common'
import { LangEnum } from '../i18n.config'

export const supportedLangs = [
  { name: 'zh-TW', code: 'zh-tw', language: 'zh-TW', text: '繁體中文', 'iso-abbrev': 'zh' },
  { name: 'zh-CN', code: 'zh-cn', language: 'zh-CN', text: '简体中文', 'iso-abbrev': 'cn' },
  { name: 'ja-JP', code: 'ja', language: 'ja-JP', text: '日本語', 'iso-abbrev': 'ja' },
  { name: 'en-US', code: 'en', language: 'en-US', text: 'English', 'iso-abbrev': 'en' },
  // { name: 'th-TH', code: 'th', language: 'th-TH', text: 'ภาษาไทย', 'iso-abbrev': 'th' },
]

export const supportedLangsByCode = convertArrayToKeyedObject(supportedLangs, 'code')

export const supportedLangsByName = convertArrayToKeyedObject(supportedLangs, 'name')

function genThirdPartyLanguageMap(originMap: Record<string, any>) {
  return genObjectWithDefaultKey(originMap, LangEnum.TW)
}

// locales: https://github.com/date-fns/date-fns/tree/main/src/locale
export const dateFnsLanguageMap = genThirdPartyLanguageMap({
  [LangEnum.TW]: () => import('date-fns/locale/zh-TW'),
  [LangEnum.CN]: () => import('date-fns/locale/zh-CN'),
  [LangEnum.JP]: () => import('date-fns/locale/ja'),
  [LangEnum.ENG]: () => import('date-fns/locale/en-US'),
  [LangEnum.THAI]: () => import('date-fns/locale/th'),
})

// locales: https://github.com/tusen-ai/naive-ui/tree/0278f24ea34df0da0bdfe9a15ca627563c898771/src/locales/common
export const nUILanguageModuleMap = genThirdPartyLanguageMap({
  [LangEnum.TW]: () => import('naive-ui').then(({ zhTW, dateZhTW }) => [zhTW, dateZhTW]),
  [LangEnum.CN]: () => import('naive-ui').then(({ zhCN, dateZhCN }) => [zhCN, dateZhCN]),
  [LangEnum.JP]: () => import('naive-ui').then(({ jaJP, dateJaJP }) => [jaJP, dateJaJP]),
  [LangEnum.ENG]: () => import('naive-ui').then(({ enUS, dateEnUS }) => [enUS, dateEnUS]),
  [LangEnum.THAI]: () => import('naive-ui').then(({ thTH, dateThTH }) => [thTH, dateThTH]),
})

export const jobVacancyLanguageMap = genThirdPartyLanguageMap({
  [LangEnum.TW]: 'zh-TW',
  [LangEnum.CN]: 'zh-CN',
  [LangEnum.ENG]: 'en',
})

export const faqPageLanguageMap = genThirdPartyLanguageMap({
  [LangEnum.TW]: 'zh-tw',
})
